module.exports = __webpack_public_path__ + "2058192f7027b03378c4c1fbaca4d084.png";